import { html } from "https://cdn.jsdelivr.net/npm/lit-element@4.1.1/+esm";
import { DivContainer } from "./fields.js";

export class PersonnePhysiqueCession extends DivContainer {
	static className = "PersonnePhysiqueCession";
	
  	constructor() {
	    super();
	    this.content = () => html`
		<row-wrapper>
			<select-field label="Civilité *" required name="id_personne_physique_civilite" name="id_personne_physique_civilite">
				<option-component label="Choisir" value="0"></option-component>
				<option-component label="Madame" value="1"></option-component>
				<option-component label="Monsieur" value="2"></option-component>
			</select-field>
		</row-wrapper>
		<row-wrapper>
			<text-field label="Prénom *" required name="first_name" name="first_name"></text-field>
		</row-wrapper>
		<row-wrapper>
			<text-field label="Nom *" required name="last_name" name="last_name"></text-field>
		</row-wrapper>
		<row-wrapper>
			<text-field label="Adresse *" required name="address" name="address"></text-field>
		</row-wrapper>
		<autocomplete-ville></autocomplete-ville>
		<rcs-number-field></rcs-number-field>
		<row-with-tooltip tooltip-text="La ville du greffe dépend de l'adresse de siège social.">
			<text-field label="Greffe" name="greffe"></text-field>
		</row-with-tooltip>
	    `;
	}
}

customElements.define ("personne-physique-cession", PersonnePhysiqueCession);
